import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, PAGE_SIZE } from '../common';
import { ISalesRep, ISalesRepFilter } from './models';

export const salesRepresentativesApiSlice = createApi({
  reducerPath: 'salesRepresentatives/api',
  baseQuery: axiosBaseQuery({
    baseUrl: 'salesrepresentatives/',
  }),
  endpoints: builder => ({
    getLabs: builder.query<IState<ISalesRep>, ISalesRepFilter>({
      query: data => ({
        url: `fn/search`,
        method: 'POST',
        data,
      }),
      transformResponse: (response: IAxiosResponse<ISalesRep[]>): IState<ISalesRep> => {
        return {
          data: [...response.data],
          isEnd: !!response.data?.length && response.data?.length < PAGE_SIZE,
        };
      },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs.arg?.skip && otherArgs.arg.skip > 0) {
          responseData.data.unshift(...currentCacheData.data);
          return responseData;
        }
        return responseData;
      },
    }),
  }),
});
